import React from 'react';
import { Box, Typography, Button, Card, CardContent } from '@mui/material';
import StyledAccordion from '../../../_shared/accordion';
import srcIcon from 'assets/images/User-Question.png';

const Quota: React.FC = () => {
  const source = 'Consultations';
  const environment = process.env.REACT_APP_ENV;
  let suffix = '';
  const survey_id = '123';
  const SEID = '123';
  if (environment === 'local' || environment === 'development') {
    suffix = '.dev';
  } else if (environment === 'staging') {
    suffix = '.staging';
  }
  // UTM Sign-up URL
  const signUpUrl = `https://professionals${suffix}.newtonx.com/?utm_source=${source}&utm_medium=survey-experience&utm_campaign=consultations-${SEID}&utm_content=quota-page&utm_term=survey_id_${survey_id}`;
  const accordionItems = [
    {
      title: 'Am I going to get paid?',
      content: (
        <Typography variant="body2">
          Because you did not advance beyond the screener, you are not eligible for payment.
        </Typography>
      ),
    },
    {
      title: 'What does it mean to reach a quota?',
      content: (
        <Typography variant="body2">
          When a survey reaches its quota, it means that enough people with specific characteristics
          (like age, location, or skills) have already completed it. Once these limits are reached
          for your particular group, we have to screen out new respondents with similar
          characteristics to ensure our survey reflects a balanced sample.
        </Typography>
      ),
    },
    {
      title: 'I don’t see my question answered here.',
      content: (
        <Typography variant="body2">
          Please contact professionals@newtonx.com and we’ll be happy to assist you.
        </Typography>
      ),
    },
  ];
  return (
    <Box
      sx={{
        maxWidth: '480px',
        mx: 'auto',
        px: 2,
        py: 2,
        background: 'white',
        borderRadius: '16px',
        boxShadow:
          ' 0px 5px 12px 4px rgba(0, 0, 0, 0.09), 0px 3px 6px 0px rgba(0, 0, 0, 0.12),  0px 1px 2px -2px rgba(0, 0, 0, 0.16)',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Typography variant="h3" fontWeight={700}>
        We’ve reached our quota
      </Typography>

      <Typography variant="body2">
        It looks like we already met our quota for professionals matching your experience.
      </Typography>

      <Typography variant="body2">
        We’ll continue to reach out with opportunities. We hope to work with you soon!
      </Typography>

      <Card variant="outlined">
        <CardContent sx={{ textAlign: 'center' }}>
          <Typography variant="subtitle2" fontWeight={700} mb="8px">
            Unlock more opportunities!
          </Typography>
          <Typography variant="body2" mb="16px">
            Your latest experience helps us find surveys tailored to you. Take a moment to update
            your NewtonX Professionals Community profile
          </Typography>
          <Button
            variant="text"
            color="primary"
            fullWidth
            onClick={() => {
              window.open(signUpUrl, '_blank', 'noopener,noreferrer');
            }}
          >
            UPDATE PROFILE
          </Button>
        </CardContent>
      </Card>

      <Box>
        <Box display="flex" alignItems="center" mt={1} mb={1}>
          <Box component="img" src={srcIcon} alt="faq icon" sx={{ width: 24, height: 24, mr: 1 }} />
          <Typography variant="subtitle1" fontWeight={700}>
            Frequently Asked Questions
          </Typography>
        </Box>
        <StyledAccordion items={accordionItems} />
      </Box>
    </Box>
  );
};

export default Quota;
